import { getLoggedInUser, logUserActivity } from "./utils"

window.onload = () => {
    const qs = window.location.search
    const q = new URLSearchParams(qs)
    const select = q.get('select')

    console.log(`faq: select=${select}`)

    try {
        const user = getLoggedInUser()
        if (user) {
            logUserActivity('VIEW_FAQ', user.username, user)
        } else {
            logUserActivity('GUEST_VIEW_FAQ')
        }
    } catch (error) {
        console.error('Error in Analytics:', error)
    }


    if (!select) {
        return
    }

    const div = $(`#${select}`)
    if (!div) {
        console.error(`faq: target ${select} not found.`)
        return
    }
    // console.log(`faq: div=%O`, div)
    const buttonSelect = `#${select} .c-faq-q ._w-faq-icon`
    
    const button = $(buttonSelect)
    // console.log(`faq: button=%O`, button)
    // console.log(`faq: button[0]=%O`, button[0])
    if (button[0]) {
        button[0].click()

        setTimeout(() => {
            $.scrollTo(div, {
                offset: -150   // margin
            })
        }, 100)
    } else {
        console.error(`faq: target buttonSelect="${buttonSelect}" not found.`)
    }
}
